import { CONSORS_CONSOLIDATION_REQUEST_FAILURE_REASONS, CONSORS_CONSOLIDATION_REQUEST_STATUSES } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// export type ConsorsConsolidationsTableSchema = {
//     failureReason: CONSORS_CONSOLIDATION_REQUEST_FAILURE_REASON | null;
//     loanRequestId: string;
//     status: CONSORS_CONSOLIDATION_REQUEST_STATUS;
//     timestamp: number;
//     accessKey: string | null;
//     contractIdentifier: string | null;
//     token: string | null;
//     url: string | null;
// };

export const ConsorsConsolidationsTableDefinitionZod = z.object({
    accessKeyEncrypted: z.string().nullish(),
    contractIdentifier: z.string().nullable(),
    expiresAt: z.number().nullish(),
    failureReason: z.nativeEnum(CONSORS_CONSOLIDATION_REQUEST_FAILURE_REASONS).nullable(),
    loanRequestId: schemaId,
    status: z.nativeEnum(CONSORS_CONSOLIDATION_REQUEST_STATUSES),
    subscriptionIdentifier: z.string().nullish(),
    timestamp: z.number(),
    tokenEncrypted: z.string().nullish(),
    url: z.string().nullable(),
});

export type ConsorsConsolidationsTableSchema = z.infer<typeof ConsorsConsolidationsTableDefinitionZod>;
